export * as fin from './fin'
export * as hcm from './hcm'
export * as technical from './technical'
export * as changeManagement from './change-management'
export * as other from './other'
